var utils = {
  changeline: (w) => {
    w.replace(',', '\n')
    console.log(w)
  },
  datalist: ''
}
export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js